import React from "react";

import { BaseComponent } from "../../utils/BaseComponent";
import { Link, withRouter, RouteComponentProps } from "react-router-dom";
import { OverlayProps, Overlay } from "@schneiderpp/utils-components";
import { ParentStateDatasource, DataSourceStateIdle } from "@schneiderpp/utils-endpoint";
import { Endpoint } from "@schneiderpp/admin-endpoint";
import { ds } from "../../DataSource";
import { ROUTER_HOME } from "../home/Router";
import { FormatFloat } from "@schneiderpp/utils-generic";

interface ProductListState {
    datasource: {
        List: ParentStateDatasource<typeof Endpoint.Product.GetProductList>;
    };
}

class List extends BaseComponent<RouteComponentProps, ProductListState> {
    state: ProductListState = {
        datasource: {
            List: DataSourceStateIdle
        }
    };

    private dsList = ds(Endpoint.Product.GetProductList, this, "List", () => this.context);

    componentDidMount() {
        this.getList();
    }

    render() {
        return (
            <div className="page">
                <div className="page__header">Lista Produktów</div>
                <div className="page-buttons">
                    <Link to={ROUTER_HOME.Products.Add} className="button small">
                        Dodaj produkt
                    </Link>
                </div>
                <div className="page-table">
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="w-4 t-left">Nazwa</th>
                                <th className="w-4">Stan magazynowy</th>
                                <th className="w-4 t-right">Cena</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.productList.map(product => (
                                <tr
                                    className="clickable"
                                    key={product.ProductId}
                                    onClick={() =>
                                        this.props.history.push({
                                            pathname: ROUTER_HOME.Products.Details,
                                            search: `ProductId=${product.ProductId}`
                                        })
                                    }
                                >
                                    <td className="t-left">{product.Name}</td>
                                    <td>{product.StockAvailable}</td>
                                    <td className="t-right">{FormatFloat(product.Value)} PKT</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <Overlay {...this.overlayProps} />
            </div>
        );
    }

    get productList() {
        const dsListData = this.dsList.dataSourceStorage;
        if (dsListData.state === "completed") {
            return dsListData.response.products;
        }
        return [];
    }

    get overlayProps(): OverlayProps {
        if (this.dsList.state === "pending" || this.dsList.state === "idle") {
            return {
                show: true,
                title: "Ładowanie..."
            };
        }
        if (this.dsList.state === "error") {
            return {
                show: true,
                title: "Coś poszło nie tak",
                description: typeof this.dsList.error === "string" ? this.dsList.error : "",
                children: (
                    <div className="overlay__children">
                        <button onClick={() => this.getList()} className="button light">
                            Spróbuj ponownie
                        </button>
                    </div>
                )
            };
        }
        return {
            show: false
        };
    }

    private getList() {
        this.dsList.request({});
    }
}

export default withRouter(List);
